(() => {
  const $$ = (selector, root = document) =>
    Array.from(root.querySelectorAll(selector));

  class ThemeSlider {
    constructor(root) {
      this.root = root;
      this.slides = $$("[data-slide]", root);
      this.dots = $$("[data-slider-dot]", root);
      this.count = root.querySelector("[data-slider-count]");
      this.index = 0;
      this.timer = null;
      this.touchStart = null;

      root
        .querySelector("[data-slider-prev]")
        ?.addEventListener("click", () => {
          this.show(this.index - 1);
        });

      root
        .querySelector("[data-slider-next]")
        ?.addEventListener("click", () => {
          this.show(this.index + 1);
        });

      this.dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          this.show(index);
        });
      });

      root.addEventListener("mouseenter", () => this.stop());
      root.addEventListener("mouseleave", () => this.start());
      root.addEventListener("focusin", () => this.stop());
      root.addEventListener("focusout", () => this.start());

      root.addEventListener(
        "touchstart",
        (event) => {
          this.touchStart = event.touches[0]?.clientX;
        },
        { passive: true }
      );

      root.addEventListener(
        "touchend",
        (event) => {
          if (this.touchStart == null) return;

          const distance =
            event.changedTouches[0].clientX - this.touchStart;

          if (Math.abs(distance) > 50) {
            this.show(this.index + (distance < 0 ? 1 : -1));
          }

          this.touchStart = null;
        },
        { passive: true }
      );

      this.start();
    }

    show(next) {
      if (!this.slides.length) return;

      this.index =
        (next + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, index) => {
        const active = index === this.index;

        slide.classList.toggle("is-active", active);
        slide.setAttribute(
          "aria-hidden",
          active ? "false" : "true"
        );
      });

      this.dots.forEach((dot, index) => {
        dot.classList.toggle(
          "is-active",
          index === this.index
        );
      });

      if (this.count) {
        this.count.textContent = String(
          this.index + 1
        ).padStart(2, "0");
      }

      this.start();
    }

    start() {
      this.stop();

      if (
        this.root.dataset.autoplay !== "true" ||
        matchMedia(
          "(prefers-reduced-motion: reduce)"
        ).matches ||
        this.slides.length < 2
      ) {
        return;
      }

      this.timer = setInterval(
        () => this.show(this.index + 1),
        Number(this.root.dataset.delay) || 7000
      );
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = null;
    }
  }

  function setupSliders() {
    $$("[data-slider]").forEach((root) => {
      if (root.dataset.sliderReady) return;

      root.dataset.sliderReady = "true";
      new ThemeSlider(root);
    });
  }

  function showCartToast(message = "Added to your bag") {
    const toast = document.querySelector(
      "[data-cart-toast]"
    );

    if (!toast) return;

    const label = toast.querySelector(
      "[data-cart-message]"
    );

    if (label) {
      label.textContent = message;
    }

    toast.classList.add("is-visible");
    toast.setAttribute("aria-hidden", "false");

    clearTimeout(window.antyaksriToastTimer);

    window.antyaksriToastTimer = setTimeout(() => {
      toast.classList.remove("is-visible");
      toast.setAttribute("aria-hidden", "true");
    }, 4200);
  }

  async function submitProductForm(event) {
    const form = event.currentTarget;

    event.preventDefault();

    const button = form.querySelector(
      '[type="submit"]'
    );

    if (
      form.dataset.antySubmitting === "true" ||
      button?.disabled
    ) {
      return;
    }

    const label =
      button && button.querySelector("[data-add-text]");

    const original = label
      ? label.textContent
      : button?.textContent;

    const priorBusy =
      button && button.getAttribute("aria-busy");

    const formError = form.querySelector(
      "[data-product-error]"
    );

    if (formError) {
      formError.hidden = true;
    }

    form.dataset.antySubmitting = "true";

    if (button) {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
    }

    if (label) {
      label.textContent = "Adding…";
    } else if (button) {
      button.textContent = "Adding…";
    }

    let added = false;

    const routesRoot =
      (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      ) || "/";

    try {
      const response = await fetch(
        routesRoot + "cart/add.js",
        {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          body: new FormData(form)
        }
      );

      let item;

      try {
        item = await response.json();
      } catch (error) {
        throw new Error(
          "Connection interrupted. Check your cart before trying again."
        );
      }

      if (!response.ok) {
        throw new Error(
          item.description ||
          item.message ||
          "Could not add this product."
        );
      }

      added = true;

      if (window.AntyCartDrawer) {
        await window.AntyCartDrawer.refresh(false);
        window.AntyCartDrawer.open();
      } else {
        window.location.assign(routesRoot + "cart");
      }
    } catch (error) {
      if (added) {
        window.location.assign(routesRoot + "cart");
      } else {
        const message =
          error.message ||
          "Connection interrupted. Check your cart before trying again.";

        showCartToast(message);

        if (formError) {
          formError.textContent = message;
          formError.hidden = false;
        }
      }
    } finally {
      delete form.dataset.antySubmitting;

      const selected = form.querySelector(
        "[data-variant-option]:checked"
      );

      const soldOut =
        selected &&
        selected.dataset.available === "false";

      if (button) {
        button.disabled = Boolean(soldOut);

        if (priorBusy === null) {
          button.removeAttribute("aria-busy");
        } else {
          button.setAttribute(
            "aria-busy",
            priorBusy
          );
        }
      }

      if (label) {
        label.textContent = soldOut
          ? "Sold out"
          : original;
      } else if (button) {
        button.textContent = original;
      }
    }
  }

  function setupProductForms() {
    $$('form[action*="/cart/add"]').forEach((form) => {
      if (form.dataset.ajaxReady === "true") return;

      form.dataset.ajaxReady = "true";

      form.addEventListener(
        "submit",
        submitProductForm
      );
    });
  }

  $$('form[action*="/cart/add"]').forEach((form) => {
    if (form.dataset.ajaxReady) return;

    form.dataset.ajaxReady = "true";

    form.addEventListener(
      "submit",
      submitProductForm
    );
  });

  function setupProductGallery() {
    $$("[data-product-thumb]").forEach((button) => {
      button.addEventListener("click", () => {
        const image = document.querySelector(
          ".main-product-image"
        );

        if (image && button.dataset.imageSrc) {
          image.src = button.dataset.imageSrc;
        }
      });
    });
  }

  function setupSorting() {
    $$("[data-sort-select]").forEach((select) => {
      select.addEventListener("change", () => {
        const url = new URL(window.location.href);

        url.searchParams.set(
          "sort_by",
          select.value
        );

        window.location.assign(url.toString());
      });
    });
  }

  function setupMenus() {
    $$(".mobile-menu a").forEach((link) => {
      link.addEventListener("click", () => {
        link.closest("details")?.removeAttribute("open");
      });
    });

    document.addEventListener("click", (event) => {
      $$(".mobile-menu[open]").forEach((menu) => {
        if (!menu.contains(event.target)) {
          menu.removeAttribute("open");
        }
      });
    });
  }

  function setupProductQuantity() {
    document
      .querySelectorAll("[data-product-quantity-input]")
      .forEach((input) => {
        const control = input.closest(
          ".product-quantity__control"
        );

        if (
          !control ||
          control.dataset.quantityReady === "true"
        ) {
          return;
        }

        control.dataset.quantityReady = "true";

        control
          .querySelector("[data-product-quantity-minus]")
          ?.addEventListener("click", () => {
            const currentQuantity =
              Number(input.value) || 1;

            input.value = Math.max(
              1,
              currentQuantity - 1
            );
          });

        control
          .querySelector("[data-product-quantity-plus]")
          ?.addEventListener("click", () => {
            const currentQuantity =
              Number(input.value) || 1;

            input.value = currentQuantity + 1;
          });
      });
  }

  function init() {
    setupSliders();
    setupProductForms();
    setupProductGallery();
    setupSorting();
    setupMenus();
    setupProductQuantity();

    document
      .querySelector("[data-cart-toast-close]")
      ?.addEventListener("click", (event) => {
        event.currentTarget
          .closest("[data-cart-toast]")
          ?.classList.remove("is-visible");
      });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();